export default __webpack_public_path__ + "static/media/AppraisalWF1.9ec6ae47.png";